import { useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import setPanel from "@Redux/Actions/panel";
import useWindowSize from "./useWindowSize";

export default function usePanelVisibility() {
	const dispatch = useDispatch();
	const activePanel = useSelector((state) => {
		return state.panel.activePanel;
	});
	const currentChatId = useSelector((state) => {
		return state.chats.currentChatId;
	});
	const { width } = useWindowSize();

	const isMobile = width <= 768;
	const isTablet = width > 768 && width <= 991;
	const isComputer = width > 991 && width <= 1199;
	const isDesktop = width > 1199;
	const isMobileOrTablet = isMobile || isTablet;

	const visibility = useMemo(() => {
		if (isDesktop) {
			return {
				showList: true,
				showChat: true,
				showInfo: true,
			};
		}

		if (isComputer) {
			return {
				showChat: true,
				showList: activePanel === "list",
				showInfo: activePanel === "info",
			};
		}

		if (isTablet) {
			return {
				showChat: true,
				showList: activePanel === "list",
				showInfo: activePanel === "info",
			};
		}

		return {
			showList: activePanel === "list",
			showChat: activePanel === "chat",
			showInfo: activePanel === "info",
		};
	}, [isMobile, isTablet, isComputer, isDesktop, activePanel]);

	useEffect(() => {
		if (activePanel !== "list" && !currentChatId) {
			dispatch(setPanel("list"));
		}
	}, [dispatch, activePanel, currentChatId]);

	// Navigation helpers
	const goList = () => {
		return dispatch(setPanel("list"));
	};

	const goChat = () => {
		return dispatch(setPanel("chat"));
	};

	const goInfo = () => {
		return dispatch(setPanel("info"));
	};

	return {
		activePanel,
		...visibility,
		goList,
		goChat,
		goInfo,
		isMobile,
		isTablet,
		isComputer,
		isDesktop,
		isMobileOrTablet,
	};
}
